export default __webpack_public_path__ + "static/media/music.875af5f5.mp3";